import en_US from "@/lang/edited/en-US.json"
import LeftOvers from "./LeftOvers.js"
export default {
  ...en_US,
  ...LeftOvers
}